module.exports = __webpack_public_path__ + "static/Elena-9a3ca6cf7969af6281c0560b5fc56dcd.png";